var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mapContent"},[_c('div',{staticClass:"divwxMap",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"divwxMap"}}),_c('cun-mode',{ref:"cunMode"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }